<template>
  <el-dialog
    title="提示"
    :visible.sync="dialogVisible"
    width="600px"
 >
    <div>
        <div>下列供应商没有{{platformName}}面单，可能无法进行{{PLATFORMS[platform] && PLATFORMS[platform].name}}订单发货。建议先联系供销商，明确订单可发货后再铺货。</div>
        <el-table
            :data="tableData"
            style="width: 100%"
            :height="200"
        >
            <el-table-column prop="companyName" label="供销商"></el-table-column>
            <el-table-column prop="contact" label="联系人"></el-table-column>
            <el-table-column prop="phone" label="联系方式"></el-table-column>
        </el-table>
    </div>
    <span slot="footer" class="dialog-footer">
        <el-button @click="() => publish()">忽略，继续铺货</el-button>
        <el-button @click="()=> publish(1)">跳过相关商品，继续铺货</el-button>
        <el-button type="primary" @click="cancel">暂不铺货</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { queryUnopenedSuppliers } from '@/api/prod/center';
import { PLATFORMS } from '@/dictionary/platforms';
export default {
    props:{},
    data(){
        return {
            dialogVisible:false,
            platform:'',
            platformName:'',
            tableData:[],
            PLATFORMS:PLATFORMS,
            canPublishBaseItemIds:[],
            resolveFn:null,
        }
    },
    methods:{
        open(platform, baseItemIds,params={}) {
            // * loginIdentity(1:供销商； 2:分销商)
            let userInfo = this.$store.getters.userInfo;
            let isSupplier = userInfo.loginIdentity === 1 ? true : false;
            let checkplatform = ['tb','tm','1688','pdd','jd','fxg','kuaishou','wxsph','xhs']; // 需要检验的平台
            return new Promise((resolve) => {
                if((!isSupplier && checkplatform.includes(platform)) || params.origin === 'hyc'){
                    this.platform = platform
                    this.resolveFn = resolve;
                    this.query(platform, baseItemIds);
                }else{
                    resolve()
                }
            });
        },
        query(platform, baseItemIds) {
            queryUnopenedSuppliers({ platform, baseItemIds }).then(res => {
                this.canPublishBaseItemIds = res?.data?.canPublishBaseItemIds || [];
                if (res.data && res.data.unopenedSuppliers && res.data.unopenedSuppliers.length) {
                    this.tableData = res?.data?.unopenedSuppliers || [];
                    this.platformName = res.data?.platformName || ''
                    this.dialogVisible = true;
                } else {
                    this.publish();
                }
            });
        },
        publish(type) {
            if (type === 1) {
                if(!this.canPublishBaseItemIds.length){
                    return this.$message.error('当前没有可以铺货的商品！')
                }
                this.dialogVisible = false
                this.resolveFn && this.resolveFn(this.canPublishBaseItemIds);
            } else {
                this.dialogVisible = false
                this.resolveFn && this.resolveFn();
            }
        },
        cancel() {
            this.dialogVisible = false;
            this.resolveFn && this.resolveFn('CANCEL');
        }
    }
}
</script>

<style lang="scss" scoped>

</style>